import React from 'react'
import clsx from 'clsx'
import style from './style.module.scss'
import { SimpleCircleChart } from 'components/charts';

const BaseballViewRecord = ({ home, away }) => {
  return (
    <>
      <dl className={style.item}>
        <dt>순위</dt>
        <dd
          className={
            away.seasonRecord.ranking < home.seasonRecord.ranking ? style.on : ''
          }>
          {away.seasonRecord.ranking}
        </dd>
        <dd
          className={
            home.seasonRecord.ranking < away.seasonRecord.ranking ? style.on : ''
          }>
          {home.seasonRecord.ranking}
        </dd>
      </dl>
      <dl className={style.item}>
        <dt>경기</dt>
        <dd>{away.seasonRecord.gameCount}</dd>
        <dd>{home.seasonRecord.gameCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>승</dt>
        <dd>{away.seasonRecord.winCount}</dd>
        <dd>{home.seasonRecord.winCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>무</dt>
        <dd>{away.seasonRecord.drawCount}</dd>
        <dd>{home.seasonRecord.drawCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>패</dt>
        <dd>{away.seasonRecord.defeatCount}</dd>
        <dd>{home.seasonRecord.defeatCount}</dd>
      </dl>
      <dl className={clsx(style.item, style.rate)}>
        <dt>승률</dt>
        <dd>
          <SimpleCircleChart
            value={Math.round(away.seasonRecord.winPercentage * 100)}
            text={(+away.seasonRecord.winPercentage).toFixed(3)}
          />
        </dd>
        <dd>
          <SimpleCircleChart
            value={Math.round(home.seasonRecord.winPercentage * 100)}
            text={(+home.seasonRecord.winPercentage).toFixed(3)}
          />
        </dd>
      </dl>
      <dl className={style.item}>
        <dt>연속</dt>
        <dd>{away.seasonRecord.streak}</dd>
        <dd>{home.seasonRecord.streak}</dd>
      </dl>
      <dl className={clsx(style.item, style.latest)}>
        <dt>최근 10경기</dt>
        <dd>{away.seasonRecord.performance}</dd>
        <dd>{home.seasonRecord.performance}</dd>
      </dl>
    </>
  );
};

export default BaseballViewRecord;
